import React from "react";
import { clinic } from "../mock";

export default function Alianza() {
  return (
    <section className="bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12">
        <div className="reveal flex flex-col items-center text-center">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-slate-400">
            Alianza médica
          </span>
          <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-14 mt-7">
            <img
              src={clinic.logoSantaLucia}
              alt="Centro Oftalmológico Santa Lucía"
              className="h-20 w-auto object-contain"
            />
            <div className="h-12 w-px bg-slate-200 hidden sm:block" />
            <a href={clinic.partner.url} target="_blank" rel="noopener noreferrer">
              <img
                src={clinic.logoImagenSalud}
                alt="Imagen Salud"
                className="h-12 w-auto object-contain transition-opacity hover:opacity-80"
              />
            </a>
          </div>
          <p className="text-sm text-slate-500 mt-7 max-w-2xl leading-relaxed">
            Trabajamos junto a <span className="font-semibold text-[#0b2545]">Imagen Salud</span> para
            ofrecerte atención oftalmológica especializada de alta tecnología en San Fernando,
            Región de O'Higgins.
          </p>
        </div>
      </div>
    </section>
  );
}
